import { useMemo } from 'react';
import { useSet as useSetArray } from './array/useSet';
export function useSet(initialState = new Set()) {
    const [value, actions] = useSetArray(initialState);
    return useMemo(() => {
        return Object.assign({ value }, actions);
    }, [actions, value]);
}
//# sourceMappingURL=useSet.js.map